"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _logo_campercontact = _interopRequireDefault(require("../img/logos/logo_campercontact"));
var _logo_schier = _interopRequireDefault(require("../img/logos/logo_schier"));
var _logo_terschelling = _interopRequireDefault(require("../img/logos/logo_terschelling"));
var _logo_texel = _interopRequireDefault(require("../img/logos/logo_texel"));
var _logo_travelbase = _interopRequireDefault(require("../img/logos/logo_travelbase"));
var _logo_uitinderegio = _interopRequireDefault(require("../img/logos/logo_uitinderegio"));
var _logo_waterland = _interopRequireDefault(require("../img/logos/logo_waterland"));
var logoMap = {
  texel: _logo_texel["default"],
  terschelling: _logo_terschelling["default"],
  ameland: '../img/logos/logo_ameland.png',
  schier: _logo_schier["default"],
  uitinderegio: _logo_uitinderegio["default"],
  waterland: _logo_waterland["default"],
  travelbase: _logo_travelbase["default"],
  campercontact: _logo_campercontact["default"]
};
var getLogoForBrand = function getLogoForBrand() {
  var _process$env$REACT_AP, _logoMap;
  var brand = (_process$env$REACT_AP = process.env.REACT_APP_BRAND) !== null && _process$env$REACT_AP !== void 0 ? _process$env$REACT_AP : 'travelbase';
  var Logo = (_logoMap = logoMap[brand]) !== null && _logoMap !== void 0 ? _logoMap : logoMap.travelbase;
  if (typeof Logo === 'string') {
    var _ref;
    return /*#__PURE__*/_react["default"].createElement("img", {
      src: (_ref = logoMap[brand]) !== null && _ref !== void 0 ? _ref : '',
      alt: brand
    });
  }
  return /*#__PURE__*/_react["default"].createElement(Logo, {
    width: 300
  });
};
var _default = exports["default"] = getLogoForBrand;
//# sourceMappingURL=getLogoForBrand.js.map